import React, {Component} from "react";
import {Field, reduxForm,formValueSelector,change} from "redux-form";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import MenuItem from "material-ui/MenuItem";
import Constants from "../../../classes/constants";
import { connect } from 'react-redux';
import Paper from "material-ui/Paper";
import toastr from "toastr";
import Button from "react-bootstrap/lib/Button";
import axios from "axios";
import {AutoComplete as MUIAutoComplete} from "material-ui";
import {hashHistory} from "react-router";
import {AutoComplete, DatePicker, SelectField, TextField} from "redux-form-material-ui";
import moment from "moment";

let flag = false;
let textStyle = {style: {color: "#0FCAAA", 'font-size': '15', 'margin-Left': '5px'}};

const Label_text = ({data})=> {
  return <div><label style={textStyle.style}>{data}</label></div>;
}
const Labels = ({form_datas})=> {
  console.log(form_datas);
  var rows = [];
  for (var obj in form_datas) {
    console.log(form_datas[obj]);
    rows.push(<Label_text data={form_datas[obj].toString()}/>);
  }
  return <div>{rows}</div>;
};

let form_data = {

  Ostype: "ubuntu",
  department: "bangalore",
  designation: "chennai",
  email: "tharun.s@quikr.com",
  firstName: "Tharun",
  function: "Finance and Accounts",
  laptop: true,
  lastName: "S",
  location: "Noida",
  mailDomain: "bangalore",
  offeredDate: new Date("Fri Aug 26 2016 00:00:00 GMT+0530 (IST)"),
  payroll: "Quikr",
  phNumber: "7760282302",
  recruitType: "direct",
  reportingManager: "724 Kushal Shah Tech",
  "sub-dept": "bangalore",
  vertical: "bangalore",
  visitingCards: true,
  when: new Date("Fri Aug 26 2016 00:00:00 GMT+0530 (IST)")
};
let decline = {
  opt1: false,
  opt2: false,
  opt3: false,
  declineComments: ""
};

const renderField = (props) => (
  <input  {...props} />
);
const Comments = (() => {
  return (
    <TextField
      hintText="Enter comments if any"
      multiLine={true}
      rows={2}
      rowsMax={4}/>
  );
});

const validate = values => {
  const errors = {};
  const requiredFields = ['firstName', 'lastName', 'personalEmailId', 'contactNo', 'gender', 'location', 'officeLocation',
    'empDob', 'experience', 'highestEducation', 'skills', 'payroll', 'verticalHead', 'reportingTo', 'hrbp', 'designation',
    'function', 'department', 'subDepartment', 'erp_department','noticePeriod', 'offerDate', 'joiningDate', 'mailDomain', 'vertical', 'assets',
    'source', 'category','lineOfBusiness', 'businessCategory'];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  });
  if (values.noticePeriod) {
    if (isNaN(Number(values.noticePeriod)))
      errors.noticePeriod = "Enter a number"
  }
  if (values.experience) {
    if (isNaN(Number(values.experience)))
      errors.experience = "Enter a number"
  }

  if (values.contactNo) {
    if(isNaN(Number(values.contactNo)))
      errors.contactNo="Enter a number"
    if (values.contactNo.length > 10)
      errors.contactNo = "Enter a valid mobile number";

  }

  if (values.personalEmailId && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.personalEmailId)) {
    errors.personalEmailId = 'Invalid email address'
  }
  return errors
};
function getMenu(employees) {
  let menu = Object.assign([], employees);
  menu.sort((a, b)=> {
    return (parseInt(a.employeeCode) - parseInt(b.employeeCode))

  });
  menu = menu.map((node)=> {
    return node.employeeCode + " " + node.name;
  });
  return menu;
}
class Form extends Component {
  constructor(props) {
    super();
    this.state = {
      disabled: false,
      startDate: moment(), openSubmit: false, openDecline: false, results: [], del: 0, style2: {
        "display": "none"
      }, referral: true, decline: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpenDecline = this.handleOpenDecline.bind(this);
    this.handleCloseDecline = this.handleCloseDecline.bind(this);
    this.foos = this.foos.bind(this);
    this.openDatePicker = this.openDatePicker.bind(this);
    this.handleLobChange = this.handleLobChange.bind(this);
    this.handleFunctionChange = this.handleFunctionChange.bind(this);
  }

  foos() {


  }

  handleOpenDecline() {
    this.setState({openDecline: true});
  };

  handleCloseDecline() {
    this.setState({openDecline: false, decline: ""});
  };

  handleOpen() {
    this.setState({openSubmit: true});
  };

  handleClose() {
    this.setState({openSubmit: false});
  };

  handleChange(date) {
    this.setState({
      startDate: date
    });
  }

  handleLobChange(){
    this.props.dispatch(change('RecruitOpsForm','businessCategory',null));
  }

  handleFunctionChange(event, index, value){
    if(index === 'Sales'){
      index = 'Sales : Sales - Others'
    }
    if(index === 'Operations'){
      index = 'Operations : Operations - Others'
    }
    if(index === 'Ad - Operations'){
      index = 'Ad Sales'
    }
    this.props.dispatch(change('RecruitOpsForm','erp_department',index));
  }

  openDatePicker() {
    this.refs.dp.openDialog()
  }


  render() {
    let menu = getMenu(this.props.activeEmployees);
    console.log("URL")
    console.log(this.props);

    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        disabled={false}
        onTouchTap={()=> {
          hashHistory.push('1/recruitment/Recruiter');
          toastr.success("Candidate has joined")
        }}
      />,
    ];
    const actionDecline = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this.handleCloseDecline}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        disabled={false}
        onTouchTap={()=> {
          if (this.state.decline == "")
            toastr.error("Enter Reason");
          else {
            let request = new Object();
            request.id = this.props.params.id;
            request.rejectionReason = this.state.decline;
            axios.post(process.env.REQ_URL + "/onBoarding/rejectOffer", {data: request}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((reponse)=> {
              this.handleCloseDecline();
              hashHistory.push("/1/recruiter/onBoarding");
              toastr.success("Offer Declined");
            }).catch((error)=> {
              toastr.error("Error Occurred");
            })
          }

        }}
      />,
    ];
    const stylePaper = {

      textAlign: 'left'
    };

    const {fields, values, handleSubmit, pristine, reset, submitting} = this.props;
    console.log(this.props);
    return (
      <form onSubmit={handleSubmit((data) => {

        this.setState({disabled: true});
        if (this.props.params.id) {
          try {
            var result = this.props.submitEdit(data);
            result.then((response)=> {
              this.props.refreshForm();
              this.setState({disabled: false})

            }).catch((error)=> {
              this.props.refreshForm();
              this.setState({disabled: false});
            });
          }
          catch (error) {
            this.setState({disabled: false})
            console.log(error);
          }
        }
        else {
          let flag = confirm('Are you Sure');
          if (flag == true) {
            this.props.submitNew(data).then((response)=> {
              this.setState({disabled: false})
            }).catch((error)=> {
              this.setState({disabled: false});
            });
          }
        }
        //this.props.submit(data);
      })}>
        <div className="col-md-12 test2">
          <div className="col-md-6">
            <div className="col-md-12">
              <Paper style={stylePaper} zDepth={1}>
                <table className="table">
                  <thead>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{width: '35%'}}>
                        <Field
                          disabled={false} name="firstName"
                          component={TextField} style={{padding: 0}}
                          floatingLabelText="First Name"
                          hintText="First Name"
                          inputStyle={{'font-weight': 'bold', 'font-size': '15'}}
                          ref="fName" withRef
                        />
                      </td>
                      <td style={{width: '35%'}}>
                        <Field
                          name="lastName" component={TextField}
                          inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                          floatingLabelText="Last Name"
                          hintText="Last Name"
                          ref="lName"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="personalEmailId" component={TextField}
                          inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                          floatingLabelText="Personal Email Id"
                          hintText="Personal Email Id"
                        />
                      </td>
                      <td>
                        <Field
                          name="contactNo" component={TextField}
                          inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                          floatingLabelText="Contact No"
                          hintText="Contact No"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="gender"
                          floatingLabelText="Gender"
                          component={SelectField}
                          label="Payroll"
                        >
                          <MenuItem value={null} primaryText="&nbsp;" disabled={true} selected={true}/>
                          {Constants.genders.map((gender) => {
                            return (
                              <MenuItem value={gender} primaryText={gender}/>);
                          })}
                        </Field>
                      </td>
                      <td>
                        <Field
                          name="empDob"
                          inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                          component={DatePicker}
                          autoOk={true}
                          defaultValue={this.props.when}
                          firstDayOfWeek={0}
                          floatingLabelText="Date of Birth"
                          formatDate={(date)=> {
                            return (date.toString().substring(0, 16));
                          }}
                          hintText="Date of Birth"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="officeLocation"
                          floatingLabelText="Office Location"
                          component={SelectField}
                          label="Location"
                        >
                          <MenuItem value={null} primaryText="&nbsp;" disabled={true} selected={true}/>
                          {this.props.constants.officeLocations.map((officeLocation) => {
                            return (
                              <MenuItem value={officeLocation} primaryText={officeLocation}/>);
                          })}
                        </Field>
                      </td>
                      <td>
                        <Field
                          name="location"
                          floatingLabelText="Location"
                          component={SelectField}
                          label="Location"
                        >
                          <MenuItem value={null} primaryText="&nbsp;" disabled={true} selected={true}/>
                          {this.props.constants.locations.map((location) => {
                            return (
                              <MenuItem value={location} primaryText={location}/>);
                          })}
                        </Field>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="highestEducation" component={TextField}
                          inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                          floatingLabelText="Highest Education"
                          hintText="Highest Education"
                        />
                      </td>
                      <td>
                        <Field
                          name="institution" component={TextField}
                          inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                          floatingLabelText="Institution"
                          hintText="Institution"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td width={'25%'}>
                        <Field
                          name="experience" component={TextField}
                          inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                          floatingLabelText="Experience (in months)"
                          hintText="Experience (in months)"
                        />
                      </td>
                      <td width={'25%'}>
                        <Field
                          name="yearOfPassing" component={TextField}
                          inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                          floatingLabelText="Year of Passing"
                          hintText="Year of Passing"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="prevCompany1" component={TextField}
                          inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                          floatingLabelText="Previous Organisation 2"
                          hintText="Previous Organisation 1"
                        />
                      </td>
                      <td>
                        <Field
                          name="prevCompany2" component={TextField}
                          inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                          floatingLabelText="Previous Organisation 2"
                          hintText="Previous Organisation 2"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Paper>
            </div>

            <div className="col-md-12">
              <Paper style={stylePaper} zDepth={1}>
                <table className="table">
                  <thead>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <Field
                          name="offerDate"
                          ref="when"
                          inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                          component={DatePicker}
                          autoOk={true}
                          defaultValue={this.props.when}
                          firstDayOfWeek={0}
                          floatingLabelText="Date of Offer"
                          formatDate={(date)=> {
                            return (date.toString().substring(0, 16));
                          }}
                          hintText="Date of Offer"
                        />
                      </td>
                      <td>
                        <Field
                          name="joiningDate"
                          ref="when"
                          autoOk={true}
                          inputStyle={{'font-weight': 'bold', 'font-size': '15'}}
                          component={DatePicker}
                          defaultValue={this.props.when}
                          firstDayOfWeek={0}
                          floatingLabelText="Date of Joining"
                          formatDate={(date)=> {
                            return (date.toString().substring(0, 16));
                          }}
                          hintText="Date of joining"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="source"
                          floatingLabelText="Source"
                          component={SelectField}
                          label="Payroll"
                        >
                          <MenuItem value={null} primaryText="&nbsp;" disabled={true} selected={true}/>
                          {Constants.sources.map((payroll) => {
                            return (
                              <MenuItem value={payroll} onTouchTap={(event)=> {
                                console.log(payroll);
                                if (payroll == 'Referrals')
                                  this.setState({referral: false});
                                else
                                  this.setState({referral: true});

//                                if(payroll == 'Rehire')
//                                  this.setState({show: false});
//                                else
//                                  this.setState({show: true});

                              }} primaryText={payroll}/>
                            );
                          })}
                        </Field>
                      </td>
                      <td>
                        <Field
                          name="referralEmpId"
                          floatingLabelText="Employee Referrer Id"
                          component={AutoComplete}
                          openOnFocus={true}
                          disabled={this.state.referral}
                          maxSearchResults={20}
                          filter={MUIAutoComplete.caseInsensitiveFilter}
                          dataSource={menu}
                          label="Employee Referrer Id"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="assets"
                          floatingLabelText="Assets"
                          component={SelectField}
                          label="Assets"
                        >
                          <MenuItem value={null} primaryText="&nbsp;" disabled={true} selected={true}/>
                          {Constants.assets.map((payroll) => {
                            return (
                              <MenuItem value={payroll} primaryText={payroll}/>
                            );
                          })}
                        </Field>
                      </td>
                      <td>
                        <Field
                          name="mailDomain"
                          floatingLabelText="Mail Domain"
                          component={SelectField}
                          label="Payroll"
                        >
                          <MenuItem value={null} primaryText="&nbsp;" disabled={true} selected={true}/>
                          {Constants.domains.map((payroll) => {
                            return (
                              <MenuItem value={payroll} primaryText={payroll}/>
                            );
                          })}
                        </Field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Paper>
            </div>
          </div>

          <div className="col-md-6">
            <div className="col-md-12">
              <Paper style={stylePaper} zDepth={1}>
                <table className="table">
                  <thead>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{width: '35%'}}>
                        <Field
                          disabled={false} name="designation"
                          component={TextField} style={{padding: 0}}
                          floatingLabelText="Designation"
                          hintText="Designation"
                          inputStyle={{'font-weight': 'bold', 'font-size': '15'}}
                        />
                      </td>
                      <td style={{width: '35%'}}>
                        <Field
                          name="function"
                          floatingLabelText="Function"
                          component={AutoComplete}
                          hintText="Select Function"
                          filter={MUIAutoComplete.caseInsensitiveFilter}
                          dataSource={Constants.functions}
                          openOnFocus={true}
                          onChange = {this.handleFunctionChange}
                          label="Function"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="department"
                          hintText="Select Department"
                          openOnFocus={true}
                          floatingLabelText="Department"
                          component={AutoComplete}
                          filter={MUIAutoComplete.caseInsensitiveFilter}
                          dataSource={Constants.departments}
                          label="Department"
                        />
                      </td>
                      <td>
                        <Field
                          name="subDepartment"
                          hintText="Select Sub Department"
                          floatingLabelText="Sub Department"
                          component={AutoComplete}
                          openOnFocus={true}
                          filter={MUIAutoComplete.caseInsensitiveFilter}
                          dataSource={Constants.subDepartments}
                          label="Sub Department"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="erp_department"
                          hintText="Select Department for ERP"
                          floatingLabelText="Department for ERP"
                          component={AutoComplete}
                          openOnFocus={true}
                          filter={MUIAutoComplete.caseInsensitiveFilter}
                          dataSource={Constants.erp_department}
                          label="Department for ERP"
                        />
                      </td>
                      <td>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="reportingTo"
                          floatingLabelText="Reporting Manager"
                          component={AutoComplete}
                          openOnFocus={true}
                          maxSearchResults={20}
                          filter={MUIAutoComplete.caseInsensitiveFilter}
                          dataSource={menu}
                          label="Reporting Manager"
                        />
                      </td>
                      <td>
                        <Field
                          name="payroll"
                          floatingLabelText="Payroll"
                          component={SelectField}
                          label="Payroll"
                        >
                          <MenuItem value={null} primaryText="&nbsp;" disabled={true} selected={true}/>
                          {this.props.constants.payrolls.map((payroll) => {
                            return (
                              <MenuItem value={payroll} primaryText={payroll}/>
                            );
                          })}
                        </Field>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="verticalHead"
                          floatingLabelText="Vertical Head"
                          component={AutoComplete}
                          openOnFocus={true}
                          maxSearchResults={20}
                          filter={MUIAutoComplete.caseInsensitiveFilter}
                          dataSource={menu}
                          label="Vertical Head"
                        />
                      </td>
                      <td>
                        <Field
                          name="vertical"
                          floatingLabelText="Vertical"
                          component={AutoComplete}
                          openOnFocus={true}
                          filter={MUIAutoComplete.caseInsensitiveFilter}
                          dataSource={this.props.constants.verticals}
                          label="Vertical"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="hrbp"
                          floatingLabelText="HRBP"
                          component={AutoComplete}
                          openOnFocus={true}
                          maxSearchResults={20}
                          filter={MUIAutoComplete.caseInsensitiveFilter}
                          dataSource={["135 Amit Badkas"]}
                          label="HRBP"
                        />
                      </td>
                      <td>
                        <Field
                          name="noticePeriod"
                          component={TextField}
                          hintText="Notice Period (days)"
                          floatingLabelText="Notice Period"
                        />
                      </td>
                    </tr>
                    <tr>
                        <td>
                            <Field
                                name="category"
                                floatingLabelText="Category"
                                component={AutoComplete}
                                openOnFocus={true}
                                filter={MUIAutoComplete.caseInsensitiveFilter}
                                dataSource={Constants.category}
                                label="Category"
                            />
                        </td>
                        <td>
                          <Field
                            name="lineOfBusiness"
                            floatingLabelText="Line of Business"
                            component={AutoComplete}
                            openOnFocus={true}
                            filter={MUIAutoComplete.caseInsensitiveFilter}
                            dataSource={Constants.lineOfBusiness}
                            label="Line of Business"
                            onChange={this.handleLobChange}
                            menuStyle={{"maxHeight": "200px"}}
                          />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {this.props.lob && <Field
                          name="businessCategory"
                          floatingLabelText="Business Category"
                          component={AutoComplete}
                          openOnFocus={true}
                          filter={MUIAutoComplete.caseInsensitiveFilter}
                          dataSource={Constants.businessCategory[this.props.lob] || []}
                          label="Business Category"
                        />}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </Paper>
            </div>

            <div className="col-md-12">
              <Paper style={stylePaper} zDepth={1}>
                <table className="table">
                  <thead>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <Field
                          disabled={true} name="recruiter"
                          value="1766 Tharun"
                          component={TextField} style={{padding: 0}}
                          floatingLabelText={"Recruiter " + this.props.recruiter.empno + " " + this.props.recruiter.name}
                          hintText="Designation"
                          inputStyle={{'font-weight': 'bold', 'font-size': '15'}}
                        />
                      </td>
                      <td>&nbsp;</td>
                    </tr>

                    <tr>
                      <td>
                        <Field
                          name="skills" component={TextField}
                          multiLine={true}
                          rows={1}
                          rowsMax={2}
                          inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                          floatingLabelText="Candidate's Skills"
                          hintText="Skills"
                        />
                      </td>

                      <td style={{width: '90%'}}>
                        <Field
                          disabled={false} name="remarks"
                          component={TextField} style={{padding: 0}}
                          floatingLabelText="Remarks"
                          hintText="Enter Remarks (if Any)"
                          inputStyle={{'font-weight': 'bold', 'font-size': '15'}}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                              <Field
                                name="oldEmpId" component={TextField}
                                inputStyle={{color: "black", 'font-weight': 'bold', 'font-size': '15'}}
                                floatingLabelText="Old EmpId for Rehires"
                                hintText="Old EmpId for Rehires"
                              />
                            </td>

                            <td style={{width: '90%'}}>
                              <Field
                                name="legacyEmpId"
                                component={TextField} style={{padding: 0}}
                                floatingLabelText="Legacy EmpId for contracts"
                                hintText="Legacy EmpId for contracts"
                                inputStyle={{'font-weight': 'bold', 'font-size': '15'}}
                              />
                            </td>
                    </tr>
                  </tbody>
                </table>
              </Paper>
            </div>

            <div style={{"display": "block"}} className="col-md-12">
              <div>
                <Button
                  primary={true} style={{"marginRight": "20px"}} type="button"
                  onClick={()=> {
                    hashHistory.goBack();
                  }}
                >Go Back
                </Button>

                <Button
                  className="btn btn-success btn-lg" style={{"marginRight": "20px"}} type="submit"
                  primary={true}
                  disabled={pristine || submitting || this.state.disabled}
                >Save
                </Button>

                <Button
                  style={{"marginRight": "20px"}} type="button" disabled={pristine || submitting}
                  className="btn-info"
                  onClick={()=> {
                    console.log(this.props);
                    this.setState({style2: {"display": "none"}});
                    flag = false;
                    reset();
                  }}
                >Clear
                </Button>

                {this.props.params.id && window.location.hash.split('/')[2] != "admin" ?
                  <Button
                    className="btn-danger"
                    style={{"marginRight": "20px"}}
                    onClick={handleSubmit((data)=> {
                      console.log("i got what i want");
                      this.handleOpenDecline();
                      form_data = data;
                      console.log(data);
                    })}
                    type="button" disabled={false}
                  >Decline
                  </Button>
                : null}

              </div>
            </div>

            <div>
              <Dialog
                title="Reason for Candidate Declining Our Offer"
                actions={actionDecline}
                contentStyle={{height: "60%"}}
                autoScrollBodyContent={true}
                autoDetectWindowHeight={true}
                modal={false}
                open={this.state.openDecline}
              >
                <div style={{"font-family": '"Roboto", "sans-serif"'}}>
                  <TextField
                    id="declineComments"
                    onChange={(event) => {
                      this.setState({decline: event.target.value})
                    }}
                    hintText="Enter Reasons for rejecting offer"
                    fullWidth={true}
                    multiLine={true}
                    rows={2}
                    rowsMax={4}
                  />
                </div>
              </Dialog>
            </div>
          </div>

          <Dialog
            title="Dialog With Actions"
            actions={actions}
            contentStyle={{height: "60%"}}
            autoScrollBodyContent={true}
            autoDetectWindowHeight={true}
            modal={false}
            open={this.state.openSubmit}
          >
            <div style={{"font-family": '"Roboto", "sans-serif"'}}>
              <div className="col-md-4">
                {()=> {
                  for (var x in form_data) {
                    return (<label>{x}</label>);
                  }
                }}
                <label >Full Name</label>
                <br/>
                <label>DOJ</label>
                <br/>
                <label>Offered Date</label>
                <br/>
                <label>Phone Number</label>
                <br/>
                <label>Email Id</label>
                <br/>
                <label>Location</label>
                <br/>
                <label>Vertical</label>
                <br/>
                <label>Recruitment Source</label>
                <br/>
                <label>Reporting Manager</label>
                <br/>
                <label>Laptop to be provided</label>
                <br/>
                <label>Offer Status</label>
                <br/>
                <label>IT status</label>
                <br/>
                <label>Admin Status</label>
                <br/>
              </div>

              <div className="col-md-5">
                <Labels form_datas={form_data}/>
                <label style={textStyle.style}>: {form_data.firstName + " " + form_data.lastName}</label>
                <br/>
                <label style={textStyle.style}>: {form_data.phNumber}</label>
                <br/>
                <label style={textStyle.style}>: {form_data.email}</label>
                <br/>
                <label style={textStyle.style}>: {form_data.location}</label>
                <br/>
                <label style={textStyle.style}>: {form_data.vertical}</label>
                <br/>
                <label style={textStyle.style}>: {form_data.recruitType}</label>
                <br/>
                <label style={textStyle.style}>: {form_data.reportingManager}</label>
                <br/>
                <label style={textStyle.style}>: {form_data.laptop ? <label>true</label> : <label>false</label>}</label>
                <br/>

              </div>
            </div>
          </Dialog>
        </div>
      </form>
    )

  }

}

Form = reduxForm({
  form: 'RecruitOpsForm',
  validate,
})(Form)

const selector = formValueSelector('RecruitOpsForm')
Form = connect(state=>{
  const lob = selector(state,'lineOfBusiness');
  return {
    lob
  }
})(Form)


export default Form;



/** WEBPACK FOOTER **
 ** ./src/feature/onboarding/components/RecruiterForm.js
 **/